import { environment } from 'environments/environment';
import { io } from 'socket.io-client';
import { Store } from '@ngrx/store';
import { filter, map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Socket, SocketOptions } from 'socket.io-client/build/esm/socket';
import { ManagerOptions } from 'socket.io-client/build/esm/manager';
import { AppState } from '../../app.state';
import { selectAccountState } from '../../store/selectors/account.selectors';
import { GatewayNamespaces } from '@smmof/enum';

@Injectable({
  providedIn: 'root',
})
export class SocketIoService {
  socket: Socket;
  private sockets: Record<string, Socket> = {};
  wsOptions: Partial<ManagerOptions & SocketOptions> = {
    autoConnect: true,
    transports: ['websocket'],
  };

  constructor(private store: Store<AppState>) {}

  setupSocketConnection(namespace: GatewayNamespaces) {

      this.store
        .select(selectAccountState)
        .pipe(
          filter((accountState) => accountState.isAuthenticated),
          take(1),
          map((accountState) => {
            return io(`${environment.apiUrl}${namespace}`, {
              auth: {
                Authorization: `Bearer ${accountState.token.accessToken}`,
              },
              ...this.wsOptions,
            })
            }
          )
        )
        .subscribe({
          next: (socket) => {
            this.sockets[namespace] = socket;
            console.log(`Connected to namespace: ${namespace}`);
          },
          error: (err) => {
            console.error(`Error connecting to namespace: ${namespace}`, err);
          },
        });
  }

  getSocket(namespace: string): Socket | undefined {
    return this.sockets[namespace];
  }

}
